import { useEffect, useRef, type CSSProperties } from 'react';
import { heroBackgroundVideo } from '@/content/site';

export function HeroVideoBackground() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const syncPlayback = () => {
      if (media.matches) {
        video.pause();
        return;
      }
      void video.play().catch(() => {});
    };

    syncPlayback();
    media.addEventListener('change', syncPlayback);
    return () => media.removeEventListener('change', syncPlayback);
  }, []);

  if (!heroBackgroundVideo.enabled) return null;

  return (
    <div
      className="hero__video-bg"
      aria-hidden
      style={
        {
          '--hero-video-poster': `url("${heroBackgroundVideo.poster}")`,
        } as CSSProperties
      }
    >
      <video
        ref={videoRef}
        className="hero__video"
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        poster={heroBackgroundVideo.poster}
      >
        <source src={heroBackgroundVideo.webm} type="video/webm" />
        <source src={heroBackgroundVideo.mp4} type="video/mp4" />
      </video>
      <div className="hero__video-overlay" />
    </div>
  );
}
